module.exports = "<div class=\"container-hex-flex\" *ngFor=\"let row of breakRow(goals);let i = index\" (window:resize)=\"onResize($event)\" >\n  <div class=\"hex-flex max-width {{ onShowPeriod }}\" *ngFor=\"let hex of row\">\n    <div class=\"hexagon\" [ngStyle]=\"{'background-image': 'url(' + hex.image + ')'}\"></div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/keynote/components/today/components/impact-society/impact-society.component.html
// module id = ../../../../../src/app/base/components/keynote/components/today/components/impact-society/impact-society.component.html
// module chunks = main